<template>
	<div
			v-if="isTop"
			@click="scrollToTop()"
			class="fixed bottom-10 right-10 cursor-pointer w-10 h-10 shadow-4xl rounded-full scroll-top"
	>
		<img src="@/assets/icons/up-arrow.svg" alt="Scroll to top">
	</div>
</template>

<script>
    export default {
        name: "ScrollToTop"
    }
</script>

<script setup>
	import { ref, onMounted } from 'vue'
	const isTop = ref(false)

  const scrollToTop = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
  }

  onMounted(() => {
      window.addEventListener('scroll', () => {
          let scrollPos = window.scrollY
          if(scrollPos >= 500){
              isTop.value = true
          } else {
              isTop.value = false
          }
      })
  })
</script>

<style scoped>
.scroll-top {
	transition: transform .2s ease, box-shadow .2s ease;
}

.scroll-top:hover {
	transform: translateY(-4px);
	box-shadow: 0 12px 22px rgba(4, 23, 41, .22);
}

@media (prefers-reduced-motion: reduce) {
	.scroll-top {
		transition: none;
	}

	.scroll-top:hover {
		transform: none;
	}
}
</style>
